import type { CanvasItemSize } from "./canvas-resize";

export const MAX_INITIAL_IMAGE_EDGE = 560;

export function fitImageSizeToCanvas(
  source: CanvasItemSize,
  maxEdge = MAX_INITIAL_IMAGE_EDGE
): CanvasItemSize | null {
  if (!Number.isFinite(source.width) || !Number.isFinite(source.height) || source.width <= 0 || source.height <= 0 || maxEdge <= 0) return null;
  const scale = Math.min(1, maxEdge / source.width, maxEdge / source.height);
  return {
    width: Math.max(1, Math.round(source.width * scale)),
    height: Math.max(1, Math.round(source.height * scale))
  };
}

export async function canvasSizeForImageFile(file: File): Promise<CanvasItemSize | null> {
  if (typeof createImageBitmap !== "function") return null;
  try {
    const bitmap = await createImageBitmap(file);
    const size = fitImageSizeToCanvas(bitmap);
    bitmap.close();
    return size;
  } catch {
    return null;
  }
}
